// Lógica pura de "aba/título deveria mostrar indicador de não lida" —
// separada de whatsappNotifications.tsx (que importa model/whatsapp.model.ts,
// que puxa Firebase e quebra em teste sem .env, ver whatsapp.visibility.ts
// pra o mesmo achado) e do código de canvas/favicon (não dá pra testar em
// jsdom neste repo — canvas é removido antes do teste, ver CLAUDE.md).

export function formatTitleWithUnread(
  baseTitle: string,
  unreadTotal: number,
): string {
  return unreadTotal > 0 ? `(${unreadTotal}) ${baseTitle}` : baseTitle;
}

// Indicador (título com contador + favicon com bolinha) reflete
// unreadCount de verdade — NÃO depende de a aba estar em foco (mudou em
// 2026-09-22: a v1 só mostrava com a aba sem foco, e sumia assim que
// focava, mesmo sem o atendente ter feito nada — usuários reais
// reportaram isso como "a notificação sumiu sozinha, só de eu ter
// aberto a conversa"). Alinhado com a regra de negócio real: só some
// quando o atendente responde ou marca como lida (ver
// WhatsappService.markRead no backend) — abrir/focar sozinho não conta.
export function shouldShowUnreadIndicator(unreadTotal: number): boolean {
  return unreadTotal > 0;
}
